import React from "react";

const Base1 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>Base</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="base">
			<path
				id="frame_1"
				data-name="frame 1"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M1035.5,665.5v-45l-10-22s-28,10-31-19c-1.29-12.5,1.69-20.17,5.5-24.85-3.5-11.15-12.5-34.15-12.5-34.15s27-73,75-71,77,20,83,31,13,41,13,45-6,11-5,13,12,31-11,75c-12,33-36,31-36,31v21s54,34,60,47,12,36,10,47a133.1,133.1,0,0,0,0,41c1.79,11.06,7.84,25.14,9,29,4.27,14.24,23,57,28,163,0,0,18,64,8,70s-34,13-46,4-8-61,4-70-13-44-17-89c-4,44-151,33-151,33l-13-131-17,1-12,22s-11,22-18,34c2,23,1,110-3,133,0,6,0,9,8,10s15,6,19,14-1,18-1,18,11,7,11,20-23,54-72,5c-4-14,0-40,0-40s-23-82-21-130c0-18,9-18,12-36s26-79,26-79Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);

export default Base1;
